import React from "react";
import { Font, View, Text, StyleSheet } from "@react-pdf/renderer";
import Raleway from "assets/fonts/Raleway-Regular.ttf";

Font.register({
  family: "Raleway",
  fonts: [{ src: Raleway }],
});

const styles = StyleSheet.create({
  container: {
    fontFamily: "Raleway",
    width: "100%",
    paddingTop: 0,
    marginBottom: 20,
    display: "flex",
    flexDirection: "column",
  },
  title: {
    color: "#666d79",
    fontSize: 12,
    fontWeight: 600,
    marginBottom: 10,
  },
  pillar: {
    fontSize: 12,
    fontWeight: 400,
    marginBottom: 10,
    color: "#2a3039",
  },
});

const PillarLabel = (props) => {
  const { pillar } = props;

  return (
    <View style={styles.container}>
      <Text style={styles.title}>CULTURE PILLAR</Text>
      <Text style={styles.pillar}>{pillar?.title || pillar}</Text>
    </View>
  );
};

export default PillarLabel;
